import { MapState, MapAction, MapActionType } from './types';
import { initialState } from './context';

export const mapReducer = (state: MapState, action: MapAction): MapState => {
  switch (action.type) {
    case MapActionType.SET_MAP_LOADED:
      return {
        ...state,
        isMapLoaded: true,
      };
    case MapActionType.SET_IS_SPRITES_LOADED:
      return {
        ...state,
        isSpritesLoaded: action.payload,
      };
    case MapActionType.UPDATE_STYLE:
      return {
        ...state,
        stateToUpdate: {
          selectedMapStyle: action.payload,
        },
      };
    case MapActionType.TOGGLE_SETTINGS:
      return {
        ...state,
        isMapSettingsOpen: !state.isMapSettingsOpen,
      };
    case MapActionType.CLOSE_SETTINGS:
      return {
        ...state,
        isMapSettingsOpen: false,
      };
    case MapActionType.SAVE_SETTINGS:
      return {
        ...state,
        isMapSettingsOpen: false,
        isSpritesLoaded: false,
        selectedMapStyle: state.stateToUpdate.selectedMapStyle,
        stateToUpdate: null,
      };
    case MapActionType.RESET_TO_DEFAULT:
      return {
        ...state,
        isMapSettingsOpen: false,
        selectedMapStyle: initialState.selectedMapStyle,
      };
    case MapActionType.ADD_CLICK_EVENT:
      return {
        ...state,
        mapEvents: [...state.mapEvents, action.payload],
      };
    case MapActionType.REMOVE_CLICK_EVENT:
      return {
        ...state,
        mapEvents: state.mapEvents.filter(event => event.id !== action.payload),
      };
    case MapActionType.TOGGLE_MEASURING:
      return {
        ...state,
        isMeasuring: !state.isMeasuring,
      };
    default:
      return state;
  }
};
